import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateCCEmail } from '../../store/actions/survey';
import ButtonComponent from '../FormComponents/Button';
import TextField from '../FormComponents/TextField';
import Modal from '../Modal/Modal';
import ToastMessage from '../ToastMessage/ToastMessage';
import './SurveyForm.scss';

interface CCEmailProps {
  open: boolean;
  ccEmailValue: string;
  closePopup: () => void;
  getCCEmailData: () => void;
}

function CCEmail(props: CCEmailProps) {
  const dispatch = useDispatch();
  const { open, ccEmailValue, closePopup, getCCEmailData } = props;
  const [ccEmail, setCCEmail] = useState('');
  const [formClicked, setFormClicked] = useState(false);
  const [toast, setToast] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCCEmail(ccEmailValue);
  }, [ccEmailValue]);

  const updateCCEmailFunc = () => {
    setFormClicked(true);
    dispatch(
      updateCCEmail(ccEmail, (res, message) => {
        setLoading(false);
        if (res) {
          getCCEmailData();
          setCCEmail('');
          closeModal();
        } else {
          setToast(message || 'Opps, unknown error occured.');
        }
      }),
    );
  };

  const closeModal = () => {
    closePopup();
    setFormClicked(false);
    setCCEmail(ccEmailValue || '');
  };

  return (
    <>
      <Modal
        open={open}
        onClose={closeModal}
        title={`ITU 'CC Email' for all emails`}
        button={<ButtonComponent text='Update' onClick={updateCCEmailFunc} loading={loading} />}
        data={
          <div>
            <TextField
              label='CC Email'
              id='cc-email'
              variant='outlined'
              sx={{ width: 400, mt: 2 }}
              value={ccEmail}
              onChange={e => setCCEmail(e.target.value)}
              required
              error={formClicked && !ccEmail}
            />
          </div>
        }
      />
      <ToastMessage toast={toast} close={() => setToast('')} messageType='error' />
    </>
  );
}

export default CCEmail;
